import { render, staticRenderFns } from "./ServiceGroup.vue?vue&type=template&id=1c8d6f78&scoped=true&"
import script from "./ServiceGroup.vue?vue&type=script&lang=js&"
export * from "./ServiceGroup.vue?vue&type=script&lang=js&"
import style0 from "./ServiceGroup.vue?vue&type=style&index=0&id=1c8d6f78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8d6f78",
  null
  
)

export default component.exports